<template>
    <flowy-drag-handle>
    <b-button expanded size="is-medium" class="is-left">
        {{  title }}.
        {{  description }}
    </b-button>
</flowy-drag-handle>
</template>
<script>
export default {
    
  data () {
    return {
      text: 'This is component A'
    }
  },
  props: ['remove', 'node', 'title', 'description'],
  name: "demo-block"
}

</script>


<style>

.flowy-drag-handle button {
  cursor: grab;
}

.flowy-block.draggable-mirror {
  opacity: 0.6;
}
  
  
</style>